import { UpdateRequest } from "./GlobalUpdateTypes";
import { v4 as uuid } from 'uuid';

const emptyUpdateRequest = {
    jobTitle: null,
    industryId: null,
    countryId: null,
    directPhone: null,
    mobilePhone: null,
    switchboardPhone: null,
    addressStreet: null,
    addressCity: null,
    addressProvince: null,
    addressPostalCode: null,
    fax: null,
    website: null,
    salutation: null,
    addressRegionId: null,
    leadFunctionId: null,
    leadLevelId: null,
    leadStageId: null,
    leadSourceId: null,
    accountId: null,
    isActive: null,
    company: null,
    nextActivityId: null,
    nextActivityOwnerId: null,
    nextActivityDateTime: null,
    nextActivityCadenceStepId: null,
    ownerId: null,
    sprintId: null,
    switchboardEmail: null,
    dncPhone: null,
    dncMobile: null,
    dncSwitchboard: null
} as UpdateRequest

const useGlobalUpdate = () => {
    const getNewRequest = () => {
        return { ...emptyUpdateRequest, uniqueKey: uuid() }
    }

    return { getNewRequest }
}

export default useGlobalUpdate;